<template>
  <header data-header :class="[$style.navigation, isScrolled && !isMenuOpen ? $style.headerBg : false ]">
    <a @click="goToHome" @mouseenter="$hover">
      <svg
        ref="logo"
        data-logo
        :data-short="isScrolled"
        :class="[$style.logo, isScrolled ? $style.shortLogo : '', $route.name !== 'a-new-wearable' ? $style.logoHover: '']"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 168.2 85.3">
        <path :class="[$style.hide, $style.white]" d="M155.55.3h-7a.76.76 0 0 0-.54.2.67.67 0 0 0 0 1 .76.76 0 0 0 .54.2h2.71v7.23a.71.71 0 0 0 .23.54.89.89 0 0 0 1.17 0 .71.71 0 0 0 .23-.54V1.7h2.68a.81.81 0 0 0 .55-.2.64.64 0 0 0 0-1 .81.81 0 0 0-.57-.2z"/>
        <path :class="[$style.hide, $style.white]" d="M167.92.51a1 1 0 0 0-.63-.2.81.81 0 0 0-.76.41l-3.58 6.36-3.64-6.36a.77.77 0 0 0-.76-.41 1 1 0 0 0-.63.2.63.63 0 0 0-.28.53v7.9a.71.71 0 0 0 .23.54.82.82 0 0 0 .58.22.87.87 0 0 0 .6-.22.69.69 0 0 0 .25-.54V3.58l2.86 5a.93.93 0 0 0 .33.33.87.87 0 0 0 .45.13.69.69 0 0 0 .67-.41l2.94-5.22v5.48a.71.71 0 0 0 .23.54.82.82 0 0 0 .58.22.8.8 0 0 0 .57-.23.71.71 0 0 0 .25-.52V1a.63.63 0 0 0-.26-.49z"/>
        <path :class="[$style.hide, $style.white]" d="M97.27 18.36a22.63 22.63 0 0 0-12-3.06 24.66 24.66 0 0 0-12.55 3.2 22.45 22.45 0 0 0-8.62 8.93A26.61 26.61 0 0 0 61 40.35a25.18 25.18 0 0 0 3.29 12.87 23.17 23.17 0 0 0 9.13 8.87 27.48 27.48 0 0 0 21.92 1.67 24.89 24.89 0 0 0 7.6-4 3.26 3.26 0 0 0 1.44-2.7 3.93 3.93 0 0 0-1.62-3.06 3.87 3.87 0 0 0-2.7-.9 4.67 4.67 0 0 0-3 1 16.76 16.76 0 0 1-4.82 2.43 18.27 18.27 0 0 1-17.14-2.89 15.85 15.85 0 0 1-5.73-10.21h34.2a4.11 4.11 0 0 0 3-1.12 3.77 3.77 0 0 0 1.17-2.83 28.2 28.2 0 0 0-2.7-12.6 20.19 20.19 0 0 0-7.77-8.52zM69.46 36.27a16.16 16.16 0 0 1 5.17-9.63q4.09-3.6 10.67-3.6a13.21 13.21 0 0 1 9.63 3.6 16 16 0 0 1 4.5 9.63z"/>
        <path :class="[$style.hide, $style.white]" d="M140.38 55.89h-3.06a6 6 0 0 1-4.86-2.43 9.22 9.22 0 0 1-2-6V25.2h7.64a4.33 4.33 0 0 0 3.06-1.08 3.53 3.53 0 0 0 1.17-2.7 3.73 3.73 0 0 0-1.17-2.88 4.33 4.33 0 0 0-3.06-1.11h-7.65v-13a4.5 4.5 0 1 0-9 0v13h-4.14a4.33 4.33 0 0 0-3.06 1.08 3.73 3.73 0 0 0-1.15 2.92 3.52 3.52 0 0 0 1.17 2.7 4.33 4.33 0 0 0 3.06 1.08h4.14v22.22a18.93 18.93 0 0 0 2.07 8.91 16 16 0 0 0 5.71 6.25 14.81 14.81 0 0 0 8.05 2.29h1.62a5.71 5.71 0 0 0 3.83-1.26 4.05 4.05 0 0 0 1.48-3.24 4.69 4.69 0 0 0-1.12-3.24 3.54 3.54 0 0 0-2.73-1.25z"/>
        <path :class="$style.white" d="M45.9 50.03a4.15 4.15 0 0 0-4.15 4.15v6.09a16.72 16.72 0 0 1-30.59 9.34 4.152 4.152 0 1 0-6.88 4.65 25 25 0 0 0 45.77-14v-6.09a4.15 4.15 0 0 0-4.15-4.14z"/>
        <path :class="$style.white" d="M25.03 65.35a4.15 4.15 0 1 0 0-8.3 16.72 16.72 0 1 1 16.72-16.72 4.15 4.15 0 1 0 8.3 0 25 25 0 1 0-25 25z"/>
      </svg>
    </a>
    <div :class="$style.aligner" ref="aligner">
      <div :class="$style.translater" ref="translater">
        <div :class="[$style.buyNow]" ref="buyNow">
          <!-- <LineButton @click.native="$store.dispatch('TRIGGER_CART')" v-if="true">shop now</LineButton> -->
          <a :class="isMenuOpen ? $style.dark : ''" href="#" target="_blank" @mouseenter="$hover">
            <span>BUY</span>
          </a>
        </div>
      </div>
      <Hamburger @click.native="clickBurger" @mouseenter.native="$hover" :open="isMenuOpen" />
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Hamburger
  },

  data() {
    return {
      translate: 0
    }
  },

  computed: {
    ...mapState(['isMenuOpen', 'scrollbar', 'global', 'isMenuInTransition']),

    isScrolled() {
      if (
        this.scrollbar &&
        this.scrollbar.scrollTop > window.innerHeight - 100
      ) {
        return true
      }

      return false
    }
  },

  methods: {
    goToHome() {
      this.$store.commit('SET_STATE_HERO', true)
      this.$router.push('/')
    },

    clickBurger() {
      if (this.isMenuInTransition) return
      this.$store.dispatch('TRIGGER_MENU')
    }
  }
}
</script>

<style lang="scss" module>
@import "~sass-mq/mq";

.logo {
  height: 42px;
  width: auto;
  fill: #3c3c3b;
  visibility: visible;
  cursor: pointer;

  @include mq(sm) {
    height: 58px;
    width: auto;
  }

  path {
    transition: all 0.35s ease-out;
    opacity: 1;
  }

  &.shortLogo {
    @include mq(md) {
      fill: lighten($color-dark-two, 8%);
    }

    .hide {
      opacity: 0;
      transform: translate3d(20%, 0, 0) rotateY(45deg);
    }
  }

  :global(.no-touchevents) &.logoHover:hover .white {
    @include mq(md) {
      fill: lighten($color-dark-two, 8%);
    }
  }
  :global(.no-touchevents) &.logoHover.shortLogo:hover .white {
    @include mq(md) {
      fill: $color-blue;
    }
  }
}

.buyNow {
  padding-right: 50px;
  padding-left: $giga-margin;
  white-space: nowrap;

  @include mq(sm) {
    padding-right: 75px;
  }

  a {
    display: inline-block;
    visibility: visible;
    position: relative;
    padding: 14px 30px;

    background: $color-blue;
    border-radius: 60px;

    color: $color-light;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 2px;
    overflow: hidden;

    cursor: pointer;
    transition: all 0.4s cubic-bezier(.17,.67,.59,.85);

    &:focus {
      outline: none;
    }

    &.dark {
      color: white;
      background: black;
    }

    span {
      display: flex;
      transition: all 0.3s ease-out;
    }

    :global(.no-touchevents) &:hover {
      background-color: #00FFFF;
      box-shadow: inset 0 0 50px 10px #0072ce;
    }
  }
}

.aligner {
  position: relative;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 100;

  &.alignStart {
    justify-content: flex-start;
  }
}

.navigation {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: z-index(header);
  visibility: visible;
  font-size: font-size(s);

  background: transparent;
  padding: 15px 20px;

  transition: background 0.35s ease-out;

  &.headerBg {
    background: black;
  }

  @include mq(sm) {
    visibility: hidden;
    padding: 40px;
  }

  @include mq(ds) {
    padding: $standard-margin $big-margin;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue